import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { placeBidOrder, placeSellOrder } from '../../services/secondaryQuickBuy/secondaryQuickBuy';
import { toastNotify } from '../../utils/toastNotify';
const initialState = {
  loading: false
};
export const seondaryPlaceBidOrder = createAsyncThunk('PLACE_BID_ORDER', placeBidOrder);
export const secondarySellOrderBid = createAsyncThunk('PLACE_SELL_ORDER', placeSellOrder);

export const secondaryQuickBuySlice = createSlice({
  name: 'propertyDetails',
  initialState,
  extraReducers: {
    [seondaryPlaceBidOrder.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [seondaryPlaceBidOrder.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false
      };
    },
    [seondaryPlaceBidOrder.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
      };
    },
    [secondarySellOrderBid.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [secondarySellOrderBid.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false
      };
    },
    [secondarySellOrderBid.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
      };
    },
  },
});
const { reducer } = secondaryQuickBuySlice;
export default reducer;